import React from "react";
import PhoneNav from "../PhoneNav";
import Property1Frame272 from "../Property1Frame272";
import AboutFalse from "../AboutFalse";
import BookFalse from "../BookFalse";
import SchoolFalse from "../SchoolFalse";
import Property1Frame18 from "../Property1Frame18";
import Property1Frame182 from "../Property1Frame182";
import Frame148 from "../Frame148";
import FAQ1False from "../FAQ1False";
import FAQ2False from "../FAQ2False";
import FAA3False from "../FAA3False";
import FAQ4False from "../FAQ4False";
import Footer from "../Footer";
import "./Home.css";

function Home(props) {
  const {
    image16,
    followUsOn,
    image17,
    screenshot20220312At1229,
    screenshot20220312At1230,
    testimonials,
    blog,
    accolades,
    x1,
    x2,
    x3,
    x4,
    phoneNavProps,
    property1Frame272Props,
    aboutFalseProps,
    bookFalseProps,
    schoolFalseProps,
    property1Frame18Props,
    property1Frame182Props,
    fAQ1FalseProps,
    fAQ2FalseProps,
    fAA3FalseProps,
    fAQ4FalseProps,
  } = props;

  return (
    <div className="home screen">
      <PhoneNav image22={phoneNavProps.image22} />
      <div className="frame-271">
        <div className="frame-270">
          <Property1Frame272 {...property1Frame272Props} />
        </div>
      </div>
      <AboutFalse aboutSohniJuneja={aboutFalseProps.aboutSohniJuneja} line12={aboutFalseProps.line12} />
      <BookFalse
        rectangle32={bookFalseProps.rectangle32}
        bookServices={bookFalseProps.bookServices}
        line16={bookFalseProps.line16}
      />
      <SchoolFalse
        sohniJunejaSchoolOfMakeup={schoolFalseProps.sohniJunejaSchoolOfMakeup}
        line17={schoolFalseProps.line17}
      />
      <div className="instagram">
        <div className="group-107">
          <img className="image-16" src={image16} />
          <div className="overlap-group-1">
            <div className="follow-us-on poppins-medium-tundora-16px">{followUsOn}</div>
            <img className="image-17" src={image17} />
          </div>
        </div>
        <div className="frame-24">
          <div className="screenshot-at-container">
            <img className="screenshot-2022-03-12-at-1229" src={screenshot20220312At1229} />
            <img className="screenshot-2022-03-12-at-1230" src={screenshot20220312At1230} />
          </div>
        </div>
      </div>
      <div className="testimonials">
        <div className="group-33">
          <div className="testimonials-1 poppins-medium-tundora-18px">{testimonials}</div>
        </div>
      </div>
      <Property1Frame18
        ellipse6={property1Frame18Props.ellipse6}
        vatsalaWilson={property1Frame18Props.vatsalaWilson}
        loremIpsumDolorSi={property1Frame18Props.loremIpsumDolorSi}
      />
      <div className="blog-1">
        <div className="blog-2 poppins-medium-tundora-18px">{blog}</div>
      </div>
      <Property1Frame182 {...property1Frame182Props} />
      <div className="frame-276">
        <div className="accolades poppins-medium-tundora-20px">{accolades}</div>
      </div>
      <div className="icons">
        <img className="x1" src={x1} />
        <img className="x2" src={x2} />
        <img className="icons-item" src={x3} />
        <img className="icons-item" src={x4} />
      </div>
      <Frame148 />
      <div className="frame-276-1">
        <FAQ1False frame43Props={fAQ1FalseProps.frame43Props} />
        <FAQ2False frame432Props={fAQ2FalseProps.frame432Props} />
        <FAA3False frame433Props={fAA3FalseProps.frame433Props} />
        <FAQ4False frame434Props={fAQ4FalseProps.frame434Props} />
      </div>
      <Footer />
    </div>
  );
}

export default Home;
